import {useEffect, Suspense, lazy} from 'react';
import {useSelector} from 'react-redux';
import {Route, Routes, Navigate} from 'react-router-dom';
import Loading from './page/loading';
import GlobalStyle from './styles/GlobalStyle';

function App() {
  // useMobileConnect(); // 모바일 연동
  // usePushMobile(); // 모바일 푸시
  // useSocket(); // 실시간 통신

  return (
    <>
      <GlobalStyle />
      {/* Suspense로 감싸는 부분 */}
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Landing />} />

          <Route path="/*" element={<Error />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
// 코스 스플러팅
// 원칙 1. 자주 사용하는 페이지는 제외
const MainLayout = lazy(() => import('./component/layout/MainLayout'));
const Landing = lazy(() => import('./page/landing'));
const Error = lazy(() => import('./page/error'));
